import TecmaHeader from '@/layouts/TecmaHeader'

export default function HomeHeader() {
  return <TecmaHeader activeItem="Home" />
}
